import { PaletteOptions } from "@mui/material/styles";

export const lightPalette: PaletteOptions = {
  mode: "light",
  primary: {
    main: "#00615F",
  },
  secondary: {
    main: "#1F6600",
  },
  background: {
    default: "#FFFFFF",
    paper: "#FFFFFF",
  },
};

export const darkPalette: PaletteOptions = {
  mode: "dark",
  primary: {
    main: "#5DD0CC",
  },
  secondary: {
    main: "#4FBA6D",
  },
  background: {
    default: "#06100E",
    paper: "#06100E",
  },
};
